.label {
  display: flex;
  align-items: center;
  color: var(--color-text-muted);
  font-family: var(--font-display);
  font-size: var(--font-size-caption);
  font-weight: 500;
  letter-spacing: var(--letter-spacing-ui);
  line-height: 1.5;
  text-transform: uppercase;
}
